import React from "react";

const WarrantyOnMaterial = ({ data, quotationType }) => {
  let index = 1;
  return (
    <div style={{ pageBreakInside: "avoid" }}>
      <h3 className="table-heading">Warranty on Material:</h3>

      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "25%" }}>Item</th>
            <th style={{ width: "20%" }}>Warranty</th>
            <th style={{ width: "50%" }}>Condition</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{index++}</td>
            <td>GI Pipe Structure (CEA Only)</td>
            <td>15 Years</td>
            <td>
              Warranty is void in conditions like cyclone, heavy wind damage,
              heavy rain and storms. Warranty covers manufacturing defects or
              general defects
            </td>
          </tr>
          <tr>
            <td>{index++}</td>
            <td>Polyfilm</td>
            <td>2.5 Years</td>
            <td>
              Warranty is void in conditions like cyclone, heavy wind damage,
              heavy rain and storms. Warranty is void on harm done by cutting or
              chopping or burning. Warranty covers manufacturing defects,
              tearing, patching, decoloration, or general defects.
            </td>
          </tr>
          <tr>
            <td>{index++}</td>
            <td>GI Gutter</td>
            <td>6 Years</td>
            <td>
              Warranty is void in conditions like cyclone, heavy wind damage,
              heavy rain and storms. Warranty is void on harm done by cutting or
              chopping or burning or water blockage.
            </td>
          </tr>
          <tr>
            <td>{index++}</td>
            <td>Shadenet</td>
            <td>3 Years</td>
            <td>
              Warranty is void in conditions like cyclone, heavy wind damage,
              heavy rain and storms. Warranty is void on harm done by cutting or
              chopping or burning. Warranty covers manufacturing defects,
              tearing, patching, decoloration, or general defects.
            </td>
          </tr>
          <tr>
            <td>{index++}</td>
            <td>Insect Net</td>
            <td>3 Years</td>
            <td>
              Warranty is void in conditions like cyclone, heavy wind damage,
              heavy rain and storms. Warranty is void on harm done by cutting or
              chopping or burning. Warranty covers manufacturing defects,
              tearing, patching, decoloration, or general defects.
            </td>
          </tr>
          <tr>
            <td>{index++}</td>
            <td>Tape Net</td>
            <td>3 Years</td>
            <td>
              Warranty is void in conditions like cyclone, heavy wind damage,
              heavy rain and storms. Warranty is void on harm done by cutting or
              chopping or burning. Warranty covers manufacturing defects,
              tearing, patching, decoloration, or general defects.
            </td>
          </tr>

          {quotationType !== "nvph" && quotationType !== "soilbasednvph" && (
            <tr>
              <td>{index++}</td>
              <td>Plumbing Material</td>
              <td>1 Years</td>
              <td>
                Warranty is void in conditions like cyclone, heavy wind damage,
                heavy rain and storms. Warranty is void on harm done by cutting
                or chopping or burning. Warranty covers manufacturing defects,
                tearing, patching, decoloration, or general defects.
              </td>
            </tr>
          )}
          {data?.input_info?.asPerIndustry?.includes(
            "fogger_system_netafim"
          ) && (
            <tr>
              <td>{index++}</td>
              <td>Fogger Motor</td>
              <td>1 Years</td>
              <td>
                Warranty is void in conditions like cyclone, heavy wind damage,
                heavy rain and storms. Warranty is void on harm done by cutting
                or chopping or burning. Warranty covers manufacturing defects,
                tearing, patching, decoloration, or general defects.
              </td>
            </tr>
          )}
          {quotationType !== "fanpad" &&
            quotationType !== "nvph" &&
            quotationType !== "nethouse" &&
            quotationType !== "soilbasedfanpad" &&
            quotationType !== "soilbasednvph" &&
            quotationType !== "soilbasednethouse" && (
              <>
                <tr>
                  <td>{index++}</td>
                  <td>Reservoir Motor</td>
                  <td>1 Years</td>
                  <td>
                    Warranty is void in conditions like cyclone, heavy wind
                    damage, heavy rain and storms. Warranty is void on harm done
                    by cutting or chopping or burning. Warranty covers
                    manufacturing defects, tearing, patching, decoloration, or
                    general defects.
                  </td>
                </tr>
              </>
            )}
        </tbody>
      </table>

      <p className="mb-0">
        <strong>Notes: </strong>
        KBPL manufacturs and procures material from various manufacturer and
        vendors in order to provide you the best products. All warrenties on
        said items are provided by direct manufacturers / KBPL on pro-rata
        basis. KBPL team will co-ordinate with manufacturer and local service
        supplier to avail best warranty benefit to you. On replacement of
        product, KBPL ground team will get re-installation or re-commissioning
        done at extra cost.
      </p>
      <span>
        To get the details of warranty condition please refer{" "}
        <a href="https://alpha-dev.kryzen.com/warranty">
          alpha.kryzen.com/warranty
        </a>
      </span>
    </div>
  );
};

export default WarrantyOnMaterial;
